import React from 'react';
import Layout from '../components/Layout/Layout';
import Seo from '../components/Seo/Seo';
import PlanSite from '../components/PlanSite/PlanSite';

const Plan = () => {
  return (
    <Layout>
      <Seo title="COS - Plan du site" description="COS - Plan du site" />
      <PlanSite />
    </Layout>
  );
};

export default Plan;
